import { analytics, type AnalyticsEventProperties } from '@/analytics/client';

type AnalyticsOutcome = 'attempted' | 'succeeded' | 'failed';

type AnalyticsEventName =
  | 'app_page_viewed'
  | 'auth_sign_in'
  | 'auth_session_started'
  | 'auth_session_ended'
  | 'calendar_hold_created'
  | 'calendar_time_block_created'
  | 'calendar_time_block_deleted'
  | 'appointment_created'
  | 'appointment_updated'
  | 'pos_checkout'
  | 'gift_card_issued'
  | 'gift_card_adjusted'
  | 'gift_card_status_updated'
  | 'gift_card_delivery_resent'
  | 'payment_intent_created'
  | 'setup_intent_created'
  | 'refund_created'
  | 'terminal_connection_token_requested'
  | 'terminal_reader_discovered'
  | 'terminal_reader_connected'
  | 'terminal_reader_disconnected'
  | 'terminal_payment_intent_created'
  | 'terminal_payment_collected'
  | 'terminal_payment_processed'
  | 'terminal_payment_captured'
  | 'terminal_payment_failed'
  | 'client_profile_saved'
  | 'client_form_requested'
  | 'client_notification_dispatched'
  | 'staff_profile_saved'
  | 'service_saved'
  | 'product_saved'
  | 'location_settings_saved'
  | 'time_clock_action'
  | 'time_clock_break_action'
  | 'pay_adjustment_created'
  | 'payroll_run_created'
  | 'payroll_export_created'
  | 'report_rebuilt';

function errorType(error: unknown) {
  if (error && typeof error === 'object' && 'code' in error && typeof error.code === 'string') {
    return error.code;
  }

  return error instanceof Error ? error.name : 'unknown_error';
}

export function trackEvent(eventName: AnalyticsEventName, properties: AnalyticsEventProperties = {}) {
  analytics.track(eventName, properties);
}

export function trackOutcome(
  eventName: AnalyticsEventName,
  outcome: AnalyticsOutcome,
  properties: AnalyticsEventProperties = {},
) {
  trackEvent(eventName, {
    ...properties,
    outcome,
  });
}

export function trackFailure(
  eventName: AnalyticsEventName,
  error: unknown,
  properties: AnalyticsEventProperties = {},
) {
  trackOutcome(eventName, 'failed', {
    ...properties,
    error_type: errorType(error),
  });
}
